/** Высота иконок панели — перенос `const val HEIGHT = 40.0` из AppFC.kt:66. */
export const HEIGHT = 40;

/** Задержка перед выделением первой строки после загрузки (AppFCFun.kt:379). */
export const ROW_SELECT_DELAY_MS = 500;
